import styled from 'styled-components';

import { themeSpace } from 'styles/themeUtils';

export const StyledList = styled.ul`
  width: 100%;
  margin-bottom: ${themeSpace(3)};
`;

StyledList.displayName = 'StyledList';

export const StyledListItem = styled.li`
  margin-bottom: ${themeSpace(1)};
`;

StyledListItem.displayName = 'StyledListItem';
